// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4531":"b1104818","4817":"e790e880","5157":"ecd9b5a6","5744":"33b69ede","8410":"ecd9b5a6","9246":"ecd9b5a6"}[chunkId] + ".chunk.css";
};